import flatpickr from 'flatpickr';
import { Ukrainian } from "flatpickr/dist/l10n/uk"
import { default as English } from "flatpickr/dist/l10n/default"

const flatpickrLocale = (locale = 'uk') => {
  const locales = {
    'uk': Ukrainian,
    'en': English
  }
  return locales[locale]
}


$(document).on('ready turbolinks:load', function () {
  initDatePicker()
});

class FlatpickrOptions {
  constructor(params) {
    this.state = { ...params };
  }
  setOptions(newState) {
    this.state = newState;
  }
  getOptions() {
    return this.state;
  }
}

export function initDatePicker(selector = '.date-picker') {
  const datePickElements = document.querySelectorAll(selector)
  const userLocale = document.getElementsByClassName('header')?.[0]?.dataset['selectedLocale']
  const flatpickrOptions = new FlatpickrOptions({
    allowInput: true,
    locale: flatpickrLocale(userLocale)
  })

  if (datePickElements.length === 1) {
    const el = datePickElements[0];
    flatpickrOptions.setOptions({
      ...flatpickrOptions.getOptions(),
      minDate: el.attributes.min ? el.attributes.min.value : undefined,
      maxDate: el.attributes.max ? el.attributes.max.value : undefined
    })
    flatpickr(datePickElements, flatpickrOptions.getOptions());
    return;
  }
  flatpickr(datePickElements, flatpickrOptions.getOptions())
}
